import React from "react";
import "./styles.scss";

const PageSummary = ({ children }) => {
    return <div className="page-summary">{children}</div>;
};

export default PageSummary;
